import {lookupShift} from '../../../constants/url';
import {useGetToken} from '../../../components/hooks/index';
import axios from 'axios';

async function useLoadLookupShift() {
  const token = useGetToken();
  try {
    const response = await axios.get(`${lookupShift}`, {
      headers: {Authorization: `Bearer ${token}`},
    });
    return response.data;
  } catch (e) {
    console.error(e); //Que hacemos con el error?
  }
}

export default useLoadLookupShift;
